import React, { useState } from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import PerformanceTour from "../Header/PerformanceTour";
import CompanionTour from "../Header/CompanionTour";
import assets from "../../assets/assets";
import {
  fullAsessment,
  hasActivity,
  hasFeature,
  hasHW,
  hasPreRead,
} from "../../utils/features";

export default function Footer({
  setFooter,
  footer,
  changeActiveMenuHome,
  changeActiveMenuHw,
  changeActiveMenuSummary,
  changeActiveMenuEngage,
  changeActiveMenuPerformance,
}) {
  const FooterActive = localStorage.getItem("footerActive") || "Home";
  const [clickPer, setClickPer] = useState(false);
  const [clickCom, setClickCom] = useState(false);

  const handleClickHome = (newActiveMenu) => {
    changeActiveMenuHome(newActiveMenu);
  };

  const handleClickHW = (newActiveMenu) => {
    changeActiveMenuHw(newActiveMenu);
  };
  const handleClickDCM = (newActiveMenu) => {
    changeActiveMenuSummary(newActiveMenu);
  };
  const handleClickEngaggement = (newActiveMenu) => {
    changeActiveMenuEngage(newActiveMenu);
  };

  const handleClickPerformance = (newActiveMenu) => {
    changeActiveMenuPerformance(newActiveMenu);
  };

  const checkALlFeaturesForASsesmentFooter =
    hasFeature("LEC_SUM") || fullAsessment || hasFeature("SELF_ASS");

  const checkAllFeaturesForHWFooter = hasHW || hasPreRead || hasActivity;

  const checkAllComunityFeaturesFooter =
    hasFeature("COMMUNITY") || hasFeature("DOUBT_SOLV");

  const getDCMRedirectPath = () => {
    if (hasFeature("LEC_SUM")) return "/Summary";
    if (fullAsessment) return "/Assessment";
    if (hasFeature("SELF_ASS")) return "/SelfAssessment";

    // fallback (safety)
    return "/HomePage";
  };

  const getHWActivtyRedirectPath = () => {
    if (hasHW) return "/Homework";
    if (hasPreRead) return "/PreRead";
    if (hasActivity) return "/Activity";

    // fallback (safety)
    return "/HomePage";
  };

  const getCommunityRedirectPath = () => {
    if (hasFeature("COMMUNITY")) return "/EngagementCommunity";
    if (hasFeature("DOUBT_SOLV")) return "/EngagementQuery";

    // fallback (safety)
    return "/HomePage";
  };

  return (
    <div className="FoterDetailContainer d-flex justify-content-center">
      <div className="d-flex FoterDetailSubContainer">
        <div
          className="FooterTextContainer home"
          onClick={(e) => {
            setFooter({ footerMenu: "Home" });
            localStorage.setItem("footerActive", "Home");
            handleClickHome("Dashboard");
          }}
        >
          <Link className="link linkUnder" to="/HomePage">
            <div className="d-flex justify-content-center">
              {FooterActive === "Home" ? (
                <img src={assets.DashboaredActiveIcon} alt="icon"></img>
              ) : (
                <img src={assets.DashboaredActiveFooterIcon} alt="icon"></img>
              )}
            </div>
            <div
              className={` ${FooterActive === "Home"
                ? "active d-flex justify-content-center mt-2 ActivefooterDetailHeading"
                : "d-flex justify-content-center mt-2 footerDetailHeading"
                }`}
            >
              Dashboard
            </div>
            {/* <div className={` ${FooterActive === 'DCM' ? "active d-flex justify-content-center mt-2 ActivefooterDetailHeading" : "d-flex justify-content-center mt-2 footerDetailHeading"}`}>Smart Class</div> */}
          </Link>
        </div>

        {checkALlFeaturesForASsesmentFooter && (
          <div
            className="FooterTextContainer digitalClass"
            onClick={(e) => {
              const path = getDCMRedirectPath();
              setFooter({ footerMenu: "DCM" });
              localStorage.setItem("footerActive", "DCM");
              localStorage.setItem("assessSubMenu", "pending");
              if (path === "/Summary") handleClickDCM("Summary");
              else if (path === "/Assessment") handleClickDCM("Assessment");
              else if (path === "/SelfAssessment")
                handleClickDCM("SelfAssessment");
            }}
          >
            <Link className="link linkUnder" to={getDCMRedirectPath()}>
              <div className="d-flex justify-content-center">
                {FooterActive === "DCM" ? (
                  <img src="/StudentImg/DcmActive.png" alt="icon"></img>
                ) : (
                  <img src="/StudentImg/DcmIcon.png" alt="icon"></img>
                )}
              </div>
              <div
                className={` ${FooterActive === "DCM"
                  ? "active d-flex justify-content-center mt-2 ActivefooterDetailHeading"
                  : "d-flex justify-content-center mt-2 footerDetailHeading"
                  }`}
              >
                Smart Class
              </div>
            </Link>
          </div>
        )}
        {checkAllFeaturesForHWFooter && (
          <div
            className="homeWork"
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              const path = getHWActivtyRedirectPath();
              setFooter({ footerMenu: "HMW" });
              localStorage.setItem("footerActive", "HMW");
              localStorage.setItem("hwSubMenu", "pending");
              localStorage.setItem("actSub", "pending");
              localStorage.setItem("summarySideMenu", "Summary");
              if (path === "/Homework") handleClickHW("Homework");
              else if (path === "/PreRead") handleClickHW("Pre-read");
              else if (path === "/Activity") handleClickHW("Activity");
            }}
          >
            <Link className="link linkUnder" to={getHWActivtyRedirectPath()}>
              <div className="d-flex justify-content-center">
                {FooterActive === "HMW" ? (
                  <img src={assets.AssignmentActiveIcon} alt="icon"></img>
                ) : (
                  <img src={assets.AssignmentIcon} alt="icon"></img>
                )}
              </div>
              <div
                className={` ${FooterActive === "HMW"
                  ? "active d-flex justify-content-center mt-2 ActivefooterDetailHeading"
                  : "d-flex justify-content-center mt-2 footerDetailHeading"
                  }`}
              >
                Smart.Assignment
              </div>
            </Link>
          </div>
        )}
        {checkAllComunityFeaturesFooter && (
          <div
            style={{ cursor: "pointer" }}
            className="Engagement"
            onClick={(e) => {
              const path = getCommunityRedirectPath();
              setFooter({ footerMenu: "Engagement" });
              localStorage.setItem("footerActive", "Engagement");
              if (path === "/EngagementCommunity")
                handleClickEngaggement("Community");
              else if (path === "/EngagementQuery")
                handleClickEngaggement("Query");
            }}
          >
            <Link className="link linkUnder" to={getCommunityRedirectPath()}>
              <div className="d-flex justify-content-center">
                {FooterActive === "Engagement" ? (
                  <img src={assets.EngagementActiveIcon} alt="icon"></img>
                ) : (
                  <img src={assets.EngagementIcon} alt="icon"></img>
                )}
              </div>
              <div
                className={` ${FooterActive === "Engagement"
                  ? "active d-flex justify-content-center mt-1 ActivefooterDetailHeading"
                  : "d-flex justify-content-center mt-1 footerDetailHeading"
                  }`}
              >
                Engagement
              </div>
            </Link>
          </div>
        )}

        {hasFeature("OL_PERF") && (
          <div style={{ cursor: "pointer" }}>
            <Link className="link linkUnder" to="/student-performance">
              <div
                onClick={(e) => {
                  setFooter({ footerMenu: "Performance" });
                  localStorage.setItem("footerActive", "Performance");
                  handleClickPerformance("Performance");
                }}
              >
                <div className="d-flex justify-content-center">
                  {FooterActive === "Performance" ? (
                    <img src={assets.PerformanceActiveIcon} alt="icon"></img>
                  ) : (
                    <img src={assets.PerformanceIcon} alt="icon"></img>
                  )}
                </div>
                <div
                  className={` ${FooterActive === "Performance"
                    ? "active d-flex justify-content-center mt-1 ActivefooterDetailHeading"
                    : "d-flex justify-content-center mt-1 footerDetailHeading"
                    }`}
                  style={{ marginTop: "4px" }}
                >
                  Performance.AI
                </div>
              </div>
            </Link>
          </div>
        )}

        <div>
          <Link className="link linkUnder">
            <div
              onClick={() => setClickCom(true)}
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <img
                src="/DCM-img/UnActiveEngg.png"
                alt="icon"
                style={{
                  width: "20px",
                  marginTop: "3px",
                  opacity: "0.9",
                  zIndex: "revert-layer",
                }}
              ></img>
              <div className="footerDetailHeading" style={{ marginTop: "5px" }}>
                Companion.AI
              </div>
            </div>
          </Link>
        </div>
      </div>
      {clickPer && <PerformanceTour setClick={setClickPer} />}
      {clickCom && <CompanionTour setClick={setClickCom} />}
    </div>
  );
}
